App.StatusPopoverComponent = Em.Component.extend
  classNames: [ 'status-popover' ]

  isTerminalState: (->
    @get('order.status') in ['complete', 'undo']
  ).property('order.status')

  # Очень странно
  hasCourier: Em.computed.bool('order.courier.id')

  courierBinding: Ember.Binding.oneWay('order.courier')

  canRestoreOrder: (->
    @get('order.status') is 'undo'
  ).property('order.status')

  shouldAssignCourier: (->
    if (@get('order.status') is 'prepared') and not @get('hasCourier')
      return true
    false
  ).property('order.status', 'hasCourier')

  canAssignCourier: (->
    @get('order.status') in [ 'confirm', 'preparing', 'prepared', 'delivery' ]
  ).property('order.status')

  nextStep: (->
    # todo i18n
    {
      pending:   'Подтвердить'
      confirm:   'Заказ начал готовиться'
      preparing: 'Заказ приготовлен'
      prepared:  'Курьер забрал заказ'
      delivery:  'Курьер доставил'
    }[@get('order.status')]
  ).property('order.status')

  message: (->
    status = @get('order.status')
    # todo i18n
    {
      pending:   'Заказ необходимо подтвердить перед осуществлением доставки.'
      confirm:   'Заказ подтвержден.'
      preparing: 'Заказ собирается.'
      prepared:  'Заказ собран.'
      delivery:  'Заказ доставляется курьером.'
      complete:  'Заказ был успешно доставлен.'
      undo:      'Заказ был отменен.'
    }[@get('order.status')]
  ).property('order.status')

  currentStatus: (->
    'status-' + @get('order.status')
  ).property('order.status')

  actions:
    assignCourier: (courier) ->
      order = @get('order')
      order.set('courier', courier)
      order.save()

      false


    changeStatusToNext: ->
      Em.run.next =>
        # todo i18n
        return false unless confirm('Сменить статус?')

        order = @get('order')
        currentStatus = order.get('status')

        switch currentStatus
          when 'pending'
            order.set('status', 'confirm').save()
          when 'confirm'
            order.set('status', 'preparing').save()
          when 'preparing'
            order.set('status', 'prepared').save()
          when 'prepared'
            order.set('status', 'delivery').save()
          when 'delivery'
            order.set('status', 'complete').save()

      false

    restoreOrder: ->
      Em.run.next =>
        # todo i18n
        if confirm 'Восстановить заказ?'
          order = @get('order')
          order.set('status', 'pending').save()
      false

    cancelOrder: ->
      Em.run.next =>
        # todo i18n
        if confirm 'Отменить заказ?'
          order = @get('order')
          order.set('status', 'undo').save()

      false

